import { useCallback, useEffect, useState } from 'react';

import { toI18n } from 'util/i18n';

import { ONE, ONE_SECOND, RETRY_MAP, ZERO } from './constants';
import { getCountDownValue } from './utils';

const useResendCountdown = (startImmediately = false) => {
  const [tries, setTry] = useState(startImmediately ? ONE : ZERO);
  const [time, setTime] = useState(RETRY_MAP[tries - ONE]);

  const timeIsActive = time > ZERO;
  const maxRetry = RETRY_MAP.length;
  const countDownValue = getCountDownValue(time);

  const buttonText = `${toI18n(
    `authentication.code.${
      timeIsActive ? 'resend_code_button' : 'resend_button'
    }`
  )}${timeIsActive ? ` ${countDownValue}` : ''}`;

  const tryAgain = useCallback(() => {
    setTry(current => current + ONE);
  }, [setTry]);

  useEffect(() => {
    if (!timeIsActive) return;

    const timeout = setTimeout(() => {
      setTime(value => value - ONE_SECOND);
    }, ONE_SECOND);

    return () => clearTimeout(timeout);
  }, [time, timeIsActive]);

  useEffect(() => {
    if (tries !== ZERO) {
      const minuend = tries < maxRetry ? tries : maxRetry;
      setTime(RETRY_MAP[minuend - ONE]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tries]);

  return { tryAgain, buttonText, timeIsActive };
};

export default useResendCountdown;
